import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import "./ProviderContainer.scss";
import PillTabs from "components/atoms/PillTabs/PillTabs";
import Provider from "./Provider";
import ParcelProviders from "./ParcelProviders";

function ProviderContainer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleTabChange = (eventKey: string) => {
    navigate(eventKey);
  };

  return (
    <div className="provider-container">
      <PillTabs
        id="provider-tabs"
        activeKey={pathname}
        onSelect={handleTabChange}
        tabItems={[
          {
            eventKey: `/settings/providers`,
            title: <FormattedMessage id="settings.providers" defaultMessage="Providers" />,
          },
          {
            eventKey: `/settings/providers/parcel`,
            title: <FormattedMessage id="settings.parcelProviders" defaultMessage="Parcel Providers" />,
          },
        ]}
      />
      <div className="mt-4">
        <Routes>
          <Route path="/" element={<Provider />} />
          <Route path="/parcel" element={<ParcelProviders />} />
        </Routes>
      </div>
    </div>
  );
}

export default ProviderContainer;
